// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";
import { defineMessages, WrappedComponentProps, injectIntl } from "react-intl";

import { DashboardPanel } from "types";
import { IAction } from "actions";
import { IState } from "states/states";
import { EmobilityViewMode } from "states/cachedstates";
import { getPanelSelection } from "guiutils";

import RfidWidget from "./RfidWidget";
import ChargerWidget from "./ChargerWidget";

interface IEMobilityWidgetExtProps {
  dashboardIndex: number;
}

interface IEMobilityWidgetProps {
  eMobilityViewMode: EmobilityViewMode | undefined;
}

const mapStateToProps = (state: IState, ownProps: IEMobilityWidgetExtProps) => {
  const { index, selection } = getPanelSelection(
    state,
    DashboardPanel.EMOBILTY,
    ownProps.dashboardIndex,
  );

  const props: IEMobilityWidgetProps = {
    eMobilityViewMode: selection?.eMobilityViewMode,
  };
  return props;
};

interface IEMobilityWidgetState {}

interface IEMobilityWidgetDispatch {}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: IEMobilityWidgetDispatch = {};
  return dispatchProps;
};

class EMobilityWidgetComponent extends React.Component<
  IEMobilityWidgetProps & IEMobilityWidgetDispatch & WrappedComponentProps,
  IEMobilityWidgetState
> {
  public render() {
    return (
      <div id="energywidget">
        {this.props.eMobilityViewMode === EmobilityViewMode.RFIDLIST ? (
          <RfidWidget />
        ) : (
          <ChargerWidget />
        )}
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(EMobilityWidgetComponent));
